export { default as Img200 } from './processed/200/Chappaquiddick.jpg';
export { default as Img400 } from './processed/400/Chappaquiddick.jpg';
export { default as Imgthumb } from './processed/thumb/Chappaquiddick.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Chappaquiddick.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Chappaquiddick.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      36,
      97,
      171
    ],
    "_population": 4101,
    "_hsl": [
      0.591358024691358,
      0.6521739130434782,
      0.40588235294117647
    ]
  },
  "LightVibrant": {
    "_rgb": [
      220,
      194,
      154
    ],
    "_population": 3494,
    "_hsl": [
      0.10101010101010098,
      0.485294117647059,
      0.7333333333333334
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      162,
      37,
      10
    ],
    "_population": 2011,
    "_hsl": [
      0.029605263157894742,
      0.8837209302325583,
      0.3372549019607843
    ]
  },
  "Muted": {
    "_rgb": [
      166,
      128,
      89
    ],
    "_population": 443,
    "_hsl": [
      0.0844155844155844,
      0.3019607843137255,
      0.5
    ]
  },
  "LightMuted": {
    "_rgb": [
      214,
      195,
      164
    ],
    "_population": 2812,
    "_hsl": [
      0.10333333333333326,
      0.37878787878787884,
      0.7411764705882353
    ]
  },
  "DarkMuted": {
    "_rgb": [
      27,
      35,
      46
    ],
    "_population": 2246,
    "_hsl": [
      0.5964912280701754,
      0.2602739726027397,
      0.14313725490196078
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Chappaquiddick.js